import Vue from 'vue';
import VueRouter from 'vue-router';
import goTo from 'vuetify/es5/services/goto';
import Home from '../components/Home';
// import Focus from '../components/Focus';
import LiveExpectancy from '../components/LifeExpectancy';
import Migrants from '../components/Migrants';
// import Compare from "../components/Compare";
import Smoking from '../components/Smoking';
import Tcals from '../components/Tcals';

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/animate', name: 'Home', component: Home },
  // { path: "/focus", name: "Focus", component: Focus },
  // { path: "/compare", name: "Compare", component: Compare },
  { path: '/migrants', name: 'Migrants', component: Migrants },
  {
    path: '/life-expectancy',
    name: 'Life expectancy',
    component: LiveExpectancy,
  },
  { path: '/smoking', name: 'Smoking', component: Smoking },
  { path: '/tcal', name: 'TCAL', component: Tcals },
];

const router = new VueRouter({
  scrollBehavior() {
    // let scrollTo = 0;
    goTo(0);
    // if (to.hash) {
    //   scrollTo = to.hash;
    // } else if (savedPosition) {
    //   scrollTo = savedPosition.y;
    // }
    // if (to.path !== from.path) {
    //   setTimeout(() => {
    //     goTo(scrollTo, { offset: 120 });
    //   }, 2000);
    // } else {
    //   goTo(scrollTo, { offset: 120 });
    // }
  },
  routes,
  mode: 'history',
});
Vue.use(VueRouter);
export default router;
